import React from 'react';
import { connect } from "react-redux";
import {Card, Container, Form, Message} from "semantic-ui-react";
import * as Validation from "../../../common/utils/Validation";
import {setBillingOrgFormValues} from "../actions/BillingOrganizationsActions";


export class AddEditBillingOrgForm extends React.Component {

    handleInputChange = (e, { name, value, change_object }) => {
        this.props.setOrgForm({ name, value, change_object });
    };

    handleDismiss = () => {
        Validation.clearMessages();
    }

    render() {

        const {
            billingOrgObject,
            formMessage, formMessageHeader, formWarningNotification, formErrorNotification
        } = this.props;

        return (
            <div className="form-page-container">
                <Container>
                    <Form>
                        <Card fluid>
                            <Card.Content>
                                <Form.Group widths="equal">
                                    <Form.Input required
                                        type="text"
                                        label="Organization Name"
                                        placeholder="Organization Name"
                                        value={billingOrgObject.orgDetail.name}
                                        name="name"
                                        change_object={"orgDetail"}
                                        onChange={this.handleInputChange}
                                    />
                                    <Form.Input
                                        type="text"
                                        label="Email"
                                        placeholder="john@email.com"
                                        value={billingOrgObject.orgDetail.email}
                                        name="email"
                                        change_object={"orgDetail"}
                                        onChange={this.handleInputChange}
                                    />
                                    <Form.Input
                                        type="text"
                                        label="Phone"
                                        placeholder="8005551234"
                                        value={billingOrgObject.orgDetail.phone}
                                        name="phone"
                                        change_object={"orgDetail"}
                                        onChange={this.handleInputChange}
                                    />
                                </Form.Group>
                            </Card.Content>
                        </Card>

                        <Card fluid>
                            <Card.Content>
                                <Form.Group widths={"equal"}>
                                    <Form.Input required
                                        type="text"
                                        maxLength="10"
                                        label="Billing A Number"
                                        placeholder="Billing A Number"
                                        value={billingOrgObject.orgBilling.billing_a_number}
                                        name="billing_a_number"
                                        change_object={"orgBilling"}
                                        onChange={this.handleInputChange}
                                    /> 
                                    <Form.Input required
                                        type="text"
                                        maxLength="10"
                                        label="Location A Number"
                                        placeholder="Location A Number"
                                        value={billingOrgObject.orgBilling.location_a_number}
                                        name="location_a_number"
                                        change_object={"orgBilling"}
                                        onChange={this.handleInputChange}
                                    />
                                    <Form.Input
                                        type="number"
                                        label="Min. Monthly Commitment"
                                        placeholder="10000"
                                        value={billingOrgObject.orgBilling.monthly_minimum_commitment}
                                        name="monthly_minimum_commitment"
                                        change_object={"orgBilling"}
                                        onChange={this.handleInputChange}
                                    />
                                    <Form.Input
                                        type="number"
                                        label="Monthly Platform Fee"
                                        placeholder="10000"
                                        value={billingOrgObject.orgBilling.monthly_platform_fee}
                                        name="monthly_platform_fee"
                                        change_object={"orgBilling"}
                                        onChange={this.handleInputChange}
                                    />
                                </Form.Group>
                            </Card.Content>
                        </Card>
                    </Form>

                    {formWarningNotification || formErrorNotification
                        ? (
                            <div style={{paddingTop: "30px"}}>
                                <Message
                                    error={formErrorNotification}
                                    warning={formWarningNotification}
                                    header={formMessageHeader}
                                    list={formMessage}
                                    // hidden={formWarning}
                                    visible={formWarningNotification || formErrorNotification}
                                    onDismiss={this.handleDismiss}
                                />
                            </div>
                        )
                        : null}
                </Container>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    billingOrgObject: state.billing.addEditBillingOrg.billingOrgObject,

    formMessage: state.marvel.message.formMessage,
    formWarningNotification: state.marvel.message.formWarningNotification,
    formErrorNotification: state.marvel.message.formErrorNotification,
    formMessageHeader: state.marvel.message.formMessageHeader,
});

const mapDispatchToProps = dispatch => ({
    setOrgForm: ({ name, value, change_object }) => {
        dispatch(setBillingOrgFormValues({ name, value, change_object }))}
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(AddEditBillingOrgForm);
